import React, { useEffect } from "react";
import { useParams } from "react-router";
import useProperties from "hooks/useProperties";
import IdentifyPortalAndListModificationComponent from "./components/IdentifyPortalAndListModificationComponent";
import PropertyDetailsPageHeader from "./components/PropertyDetailsPageHeader";
import PropertyDetailsGallery from "./components/PropertyDetailsGallery";
import PropertyDescriptionComponent from "./components/PropertyDescriptionComponent";
import PropertyInfo from "./components/PropertyInfo";
import PropertyTab from "./components/PropertyTab";
import { isObjectEmpty } from "utils/commonUtils";
import PropertyDetailsSkeleton from "components/Skeleton/PropertyDetailsSkeleton";
import MainHeader from "components/Header/MainHeader";
import { useMediaQuery } from "react-responsive";
import LocationIntelligenceComponent from "./components/LocationIntelligenceComponent";
import SearchPriceChangeChart from "components/Charts/SearchPriceChangeChart";
import RentalTabContent from "components/Card/SearchCard/components/RentalTabContent";
import { useSearchParams } from "react-router-dom";
import PropertyDetailChartsSection from "./components/PropertyDetailChartsSection";

const PropertyDetails = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const averageGrossYield = searchParams.get("average_gross_yield");
  const { propertyDetails, loadingMapProperty, getPropertyDetails } =
    useProperties();
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

  useEffect(() => {
    getPropertyDetails(id);
  }, []);

  return (
    <div>
      {isMobile ? (
        <MainHeader isSearchVisable={false} />
      ) : (
        <PropertyDetailsPageHeader />
      )}
      {loadingMapProperty ? (
        <PropertyDetailsSkeleton />
      ) : (
        !isObjectEmpty(propertyDetails) && (
          <main className="pb-[180px] md:pb-10">
            <div className="max-w-[1287px] mx-auto">
              {/* Property Gallery  */}
              <PropertyDetailsGallery />
              {/* Property Info */}
              <PropertyInfo />
            </div>
            {/* Property Tab  */}
            <PropertyTab />
            <div className="max-w-[1287px] mx-auto">
              <div className="px-5 md:px-6 lg:pl-6 max-w-[865px]">
                {/* Overview Section */}
                <PropertyDescriptionComponent />

                {/* Scan Section */}
                <div id="scan-section">
                  <IdentifyPortalAndListModificationComponent />
                </div>

                {/* Price Change Section */}
                <div id="price-section" className="mt-8">
                  <SearchPriceChangeChart property={propertyDetails} />
                </div>

                {/* Rental Income Section  */}
                <div id="rental-section" className="mt-8">
                  <RentalTabContent
                    property={{
                      ...propertyDetails,
                      average_gross_yield: averageGrossYield,
                    }}
                  />
                </div>
                {/* Location Intelligence Section */}
                <div
                  id="location-section"
                  className="mt-8 border-b border-[#F0F0F0] pb-5"
                >
                  <LocationIntelligenceComponent />
                </div>

                {/* Market Statistics Charts Section */}
                <div id="market-statistics-section" className="mt-8">
                  <PropertyDetailChartsSection />
                </div>
              </div>
            </div>
          </main>
        )
      )}
    </div>
  );
};

export default PropertyDetails;
